module.exports = __webpack_public_path__ + "media/application/images/ui/thumbs-down-red-d6375127b47fa22469da0c641907bbd5.svg";